import http from '@/base/api/public'

let apiUrl = require('@/../config/sysConfig')

// 契約状況検索检索
export const c_0001 = (params) => {
  return http.requestQuickGet(apiUrl.apiUrl_ContractStatus + '?year=' + params.year)
}



// WEBPACK FOOTER //
// ./src/module/api/c_0001.js